<template>
    <div class="wrapper-bg mkt-option-setting-page">
        <div class="main-layout coffee">
            <HeaderOther
                :setTitle="'ยินยอมเพื่อวัตถุประสงค์ทางการตลาด'"
                :setHref="'privacysettings'"
                :showLogo="true"
            />
            <div class="main-container">
                <div class="mkt-option-setting-conntainer">
                    <div class="mkt-option-setting-conntainer-body">
                        <div class="mkt-option-setting-text-container">
                            <div class="mkt-option-setting-title">
                                <span>{{ content.title }}</span>
                            </div>
                            <div
                                class="mkt-option-setting-content"
                                v-html="content.content"
                            ></div>
                        </div>
                        <div class="line" />
                        <div class="list-item">
                            <span>ยินยอม</span>
                            <label class="switch">
                                <input
                                    id="all"
                                    v-model="all"
                                    type="checkbox"
                                    value="all"
                                    @change="onChangeConditionAll()"
                                />
                                <span class="slider round"></span>
                            </label>
                        </div>
                        <!-- <div class="list-item">
                            <span>ผ่านทางอีเมล</span>
                            <label class="switch">
                                <input
                                    id="all"
                                    v-model="objData.email"
                                    type="checkbox"
                                    value="email"
                                    @change="onChangeCondition()"
                                />
                                <span class="slider round"></span>
                            </label>
                        </div>
                        <div class="list-item">
                            <span>ผ่านทาง Line</span>
                            <label class="switch">
                                <input
                                    id="all"
                                    v-model="objData.line"
                                    type="checkbox"
                                    value="line"
                                    @change="onChangeCondition()"
                                />
                                <span class="slider round"></span>
                            </label>
                        </div>
                        <div class="list-item">
                            <span>ผ่านทางโทรศัพท์ (SMS)</span>
                            <label class="switch">
                                <input
                                    id="all"
                                    v-model="objData.sms"
                                    type="checkbox"
                                    value="sms"
                                    @change="onChangeCondition()"
                                />
                                <span class="slider round"></span>
                            </label>
                        </div> -->
                    </div>
                </div>
                <button
                    id="confirm-button"
                    class="confirm-button"
                    @click="$bvModal.show('confirm_modal')"
                >
                    ยืนยัน
                </button>
            </div>
        </div>
        <ConfirmModal
            :title="confirm_modal.title"
            :content="confirm_modal.content"
            :btn-confirm-text="confirm_modal.confirmText"
            :btn-cancel-text="confirm_modal.cancelText"
            :btn-go-hometext="confirm_modal.goHometext"
            :is-confirmed="confirm_modal.isConfirmed"
            @clickConfirm="confirmUpdate()"
        />
    </div>
</template>
<script>
import Mixin from "@/mixin/Mixin";
import Locale from "@/helper/locale/locale.js";
//helper
import CacheHelper from "@/helper/CacheHelper.js";
//service
import BzbsApi from "@/core/Account/service/BzbsProfile.js";
import BzbsCustom from "@/core/Custom/service/BzbsCustom.js";
//conponent
import HeaderOther from "@/components/Header/HeaderOther.vue";
import ConfirmModal from "../component/confirmModal.vue";

export default {
    name: "MktOptionSetting",
    components: {
        ConfirmModal,
        HeaderOther,
    },
    mixins: [Mixin],
    data: function () {
        return {
            cacheHelper: new CacheHelper(),
            lbl: Locale.getLbl(),
            content: {},
            all: false,
            objData: {
                email: false,
                line: false,
                sms: false,
                ussd: false,
                notification: false,
            },
            confirm_modal: {
                title: "",
                content: "",
                confirmText: "",
                cancelText: "",
                isConfirmed: false,
            },
            success_modal: {
                title: "",
                content: "",
                goHometext: "",
            },
        };
    },

    created: async function () {
        this.handleLoading(true);
        await this.getProfileSSO();
        await this.getContent();
    },
    methods: {
        getProfileSSO() {
            return new Promise((resolve) => {
                BzbsApi.getProfileSSO(
                    this.cacheHelper.getCache("BzbsUser").token
                ).then((response) => {
                    const profile = response.data.SSOUser;
                    console.log("profile: ", profile);
                    this.objData = {
                        email: profile.StreetCafeMarketingEmail,
                        line: profile.StreetCafeMarketingLine,
                        sms: profile.StreetCafeMarketingSms,
                        ussd: profile.StreetCafeMarketingUssd,
                        notification: profile.StreetCafeMarketingNotification,
                    };
                    if (
                        this.objData.email &&
                        this.objData.line &&
                        this.objData.sms
                    )
                        this.all = true;
                    console.log("init objData: ", this.objData);
                    resolve(response);
                });
            });
        },
        getContent() {
            return new Promise((resolve) => {
                BzbsCustom.apiGetCustom(
                    "/nestle/nescafe_streetcafe/custom/nescafe_streetcafe_content.json"
                )
                    .then((response) => {
                        this.content = response.mktoptionsetting;
                        this.confirm_modal.title =
                            response.confirmmodal_marketing.header;
                        this.confirm_modal.content =
                            response.confirmmodal_marketing.body;
                        this.confirm_modal.confirmText =
                            response.confirmmodal_marketing.ok;
                        this.confirm_modal.cancelText =
                            response.confirmmodal_marketing.cancel;

                        this.success_modal.title =
                            response.alertmodal_marketing.header;
                        this.success_modal.content =
                            response.alertmodal_marketing.body;
                        this.success_modal.goHometext =
                            response.alertmodal_marketing.ok;

                        resolve(response);
                        this.handleLoading(false);
                    })
                    .catch((error) => {
                        console.log(error);
                        resolve(error);
                        this.handleLoading(false);
                    });
            });
        },
        onChangeConditionAll() {
            let objArray = Object.keys(this.objData);
            if (this.all) {
                objArray.forEach((item) => (this.objData[item] = true));
            } else {
                objArray.forEach((item) => (this.objData[item] = false));
            }
        },
        // onChangeCondition() {
        //     if (Object.keys(this.objData).every(item => this.objData[item])) {
        //         this.all = true;
        //     } else {
        //         this.all = false;
        //     }
        // },
        confirmUpdate() {
            return new Promise((resolve, reject) => {
                this.handleLoading(true);
                BzbsApi.updateConsent(
                    this.cacheHelper.getCache("BzbsUser").token,
                    this.objData
                ).subscribe(
                    (response) => {
                        this.setModalData();
                        this.$bvModal.show("confirm_modal");

                        resolve(response);
                        this.handleLoading(false);
                    },
                    (err) => {
                        reject(err);
                        this.handleLoading(false);
                    }
                );
            });
        },
        setModalData() {
            this.confirm_modal = {
                title: this.success_modal.title,
                content: this.success_modal.content,
                goHometext: this.success_modal.goHometext,
                isConfirmed: true,
            };
            console.log(this.confirm_modal.confirmText);
        },
    },
};
</script>

<style lang="scss" scoped>
@import "@/style/_mixin.scss";
$primary-color: #4d341c;
$secondary-color: salmon;
$bg-color: #dfdcd9;

.wrapper-bg {
    padding: 0;
    &::after {
        display: none;
    }
}
.main-container {
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    .confirm-button {
        margin: 20px 20px 40px;
        position: relative;
        z-index: 5;
        height: 45px;
        font-size: 16px;
        border-radius: 50px;
        border: solid 1px $color-text;
        background-color: $color-text;
        color: #fff;
        margin-top: 20px;
    }
}
.mkt-option-setting-conntainer {
    margin: 20px;
    .mkt-option-setting-conntainer-body {
        position: relative;
        z-index: 5;
        color: $color-text;
        background-color: $color-light-grey-500;
        font-size: 16px;
        padding: 20px 16px;
        border-radius: 10px;
        .mkt-option-setting-text-container {
            overflow: auto;
            max-height: 45vh;
            .mkt-option-setting-title {
                width: 100%;
                text-align: center;
                margin-bottom: 16px;
            }
            .mkt-option-setting-content {
                font-size: 14px;
            }
        }
        .mkt-option-setting-text-container::-webkit-scrollbar {
            display: none;
        }

        .line {
            width: 100%;
            height: 1px;
            background-color: #e4e4e4;
            margin-bottom: 20px;
        }
        .list-item {
            display: flex;
            justify-content: space-between;
            margin-bottom: 15px;

            span {
                font-weight: bold;
                font-size: 16px;
            }
            label {
                margin: 0;
            }
        }
    }
}
.switch {
    position: relative;
    display: inline-block;
    width: 60px;
    height: 34px;
}

.switch input {
    opacity: 0;
    width: 0;
    height: 0;
}

.slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: $color-light-grey-700;
    -webkit-transition: 0.4s;
    transition: 0.4s;
}

.slider:before {
    position: absolute;
    content: "";
    height: 26px;
    width: 26px;
    left: 4px;
    bottom: 4px;
    background-color: $color-text;
    -webkit-transition: 0.4s;
    transition: 0.4s;
}

input:checked + .slider {
    background-color: $color-light-grey-700;
}

input:focus + .slider {
    box-shadow: 0 0 1px $color-light-grey-700;
}

input:checked + .slider:before {
    -webkit-transform: translateX(26px);
    -ms-transform: translateX(26px);
    transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
    border-radius: 34px;
}

.slider.round:before {
    border-radius: 50%;
}
</style>
